import { createSelector } from 'reselect'
import { getPageParams } from 'selectors/page'
import { getAlgoliaQuery } from './algolia'
import { getSelectedFacets } from './facets'
import { urlQuery } from '../helpers/url'

export const getUserId = createSelector(getPageParams, (params): string => params.userId || '')
export const getUrlPathString = createSelector(
  [getUserId],
  (userId): string => `/account/artworks/${userId}`
)

export const getUrlStringWithParams = (params: Record<string, any>) =>
  createSelector(
    [getUrlPathString, getSelectedFacets, getAlgoliaQuery],
    (urlPathString, selectedFacets, algoliaQuery): string => {
      const queryParams = { ...selectedFacets, ...algoliaQuery, ...params }
      const queryString = urlQuery(queryParams)
      return `${urlPathString}${queryString}`
    }
  )
